import type { EditorModel } from "@/types";
import Quill from "quill";

export default (content: EditorModel): string => {
  if (typeof content === "string") {
    return content;
  }

  const element = document.createElement("div");
  const quill = new Quill(element, {});
  quill.setContents(content.ops);
  return quill.getSemanticHTML().replace(/&nbsp;/g, " ");
};
